import { Component, Input } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'insert-edit-text-area',
  templateUrl: './text-area.component.html',
  viewProviders: [
    { provide: ControlContainer, useExisting: FormGroupDirective }
  ]
})
export class TextAreaComponent {
  @Input() fieldName!: string;
  @Input() label!: string;
  @Input() required: boolean = false;

  minRows: number = 3;
  maxRows: number = 7;

  constructor(private formGroupDirective: FormGroupDirective) { }

  getFormControlField() {
    return this.formGroupDirective.form.get(this.fieldName);
  }
}
